import React from 'react'
import styled from 'styled-components'
import Header from './Header'
import Main from './Main'
import background from '../Background/b.jpg'


function Container() {
    return (
        <Wrapper>
            <Background>

            <Header/>
            <Main/>
            </Background>
        </Wrapper>
    )
}

export default Container
const Wrapper=styled.div`
background-image:url(${background});
background-position:center;
background-size:cover;
`;
const Background=styled.div`
background-image:linear-gradient(
    to top,
    rgba(0, 0, 0, 0.8) 0,
    rgba(0, 0, 0, 0) 60%,
    rgba(0, 0, 0, 0.8) 100%
  );
`;